export const AVATAR_STACK_MAX_SLOTS = 3;

/**
 * Up to 3 items show in full; beyond that, 2 avatars and a `+N` chip that takes the third slot (N = total − 2).
 * Fewer than 2 slots can't hold an avatar and a chip, so `maxSlots` is at least 2.
 */
export function getAvatarStack<T>(
  items: T[],
  maxSlots: number = AVATAR_STACK_MAX_SLOTS
): {visible: T[]; overflow: number} {
  const slots = Math.max(2, maxSlots);
  if (items.length <= slots) return {visible: items, overflow: 0};
  const visible = items.slice(0, slots - 1);
  return {visible, overflow: items.length - visible.length};
}
